<h1 mat-dialog-title>{{isNew ? 'Add emissions' : 'Edit emissions'}} for {{data.name}}</h1>
<mat-dialog-content [formGroup]="emissionsForm" autocomplete="off">
    @if (missingFactor) {
        <p class="warning">The emission factor these emissions used has been deleted. Choose another factor.</p>
    }
    @if (factors.length === 0) {
        <p class="intro">
            There are no emission factors for this organisation yet.
            {{isOrgAdmin() ? 'Add one to start recording emissions.' : 'Ask an organisation administrator to add one.'}}
        </p>
    }

    <div class="factor-row">
        <mat-form-field color="accent" class="factor">
            <mat-label>Emission factor</mat-label>
            <mat-select formControlName="factorKey" placeholder="Choose an emission factor" required>
                @for (ef of factors; track ef._key) {
                    <mat-option [value]="ef._key">{{getFactorLabel(ef)}}</mat-option>
                }
            </mat-select>
            @if (emissionFactor?.description) {
                <mat-hint>{{emissionFactor.description}}</mat-hint>
            }
            @if (emissionsForm.controls['factorKey'].hasError('required')) {
                <mat-error>Choose an emission factor</mat-error>
            }
        </mat-form-field>

        @if (isOrgAdmin()) {
            <div class="factor-buttons">
                <button mat-button color="accent" (click)="maintainEmissionFactor(emissionFactor)" [disabled]="!emissionFactor || savingFactor"
                    matTooltip="Changes this factor for every use in the organisation">Edit factor</button>
                <button mat-button color="accent" (click)="maintainEmissionFactor()" [disabled]="savingFactor">Add factor</button>
            </div>
        }
    </div>

    <ul class="facts">
        @if (data.numberPeople) {
            <li>{{formatNumber(data.numberPeople)}} {{data.numberPeople === 1 ? 'person uses' : 'people use'}} this infrastructure</li>
        }
        @if (data.numberUnits > 1) {
            <li>{{formatNumber(data.numberUnits)}} units of this infrastructure</li>
        }
        @if (data.lifetime) {
            <li>{{data.lifetime}} {{data.lifetime === 1 ? 'year' : 'years'}} lifespan</li>
        }
        @if (data.hours) {
            <li>{{formatNumber(data.hours)}} hours modelled per year</li>
        }
    </ul>

    @if (emissionFactor) {
        <div class="values">
            @if (emissionFactor.type !== EMISSION_FACTOR_TYPE.NO_USAGE) {
                <mat-form-field>
                    <mat-label>{{units}}</mat-label>
                    <input matInput class="number" formControlName="value" type="number" min="0" id="emissions-value">
                    @if (emissionsForm.controls['value'].invalid) {
                        <mat-error>Enter an amount above 0</mat-error>
                    }
                </mat-form-field>
            }
            @if (emissionFactor.type === EMISSION_FACTOR_TYPE.DISTANCE) {
                <mat-form-field>
                    <mat-label>{{units2}}</mat-label>
                    <input matInput class="number" formControlName="value2" type="number" min="0" id="emissions-value2">
                    @if (emissionsForm.controls['value2'].invalid) {
                        <mat-error>Enter a weight above 0</mat-error>
                    }
                </mat-form-field>
            }
            <mat-form-field color="accent">
                <mat-label>Rate</mat-label>
                <mat-select formControlName="rate">
                    @for (rate of rates; track rate.rate) {
                        <mat-option [value]="rate.rate">{{rate.name}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        @if (getRateWarning()) {
            <p class="warning">{{getRateWarning()}}</p>
        }

        <h4>Calculated emissions</h4>
        @if (textDescription) {
            <p [innerHTML]="textDescription"></p>
            <p [innerHTML]="textDescription2"></p>
        }@else {
            <p class="intro">Enter the amount to see the emissions.</p>
        }
    }
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close()">Cancel</button>
    <button mat-flat-button color="accent" cdkFocusInitial (click)="save()" [disabled]="!isValid() || savingFactor">{{isNew ? 'Add' : 'Save'}}</button>
</mat-dialog-actions>
